module.exports = __webpack_public_path__ + "static/mountain-33bf3ee3204a7893b856b5f6140388e7.jpg";